import { Button as MuiButton, ButtonProps } from "@mui/material";
import { token } from '../shared/theme';

const Button = (props: ButtonProps) => {
    return <MuiButton {...props} sx={{ color: (props.variant === "text" || props.variant === undefined) ? token.color.text.primaryInverted : undefined}} />
}

export default Button;